import LoadingBars from "./LoadingBars";
import NormalText from "./NormalText";
import { OrangeButton } from "./OrangeButton";
import Modal from "react-modal";
import * as theme from "../theme";
import Form from "react-bootstrap/Form";
import { useDispatch, useSelector } from "react-redux";
import DownloadFilesList from "../components/DownloadFilesList";
import {
  PossibleCoverMatchValues,
  PossibleExcelApiStatusValues,
} from "../store/helperfuncs";
import _ from "lodash";
import { getCoverIdForCoverageLevel } from "../store/businesslogic/hardwiredlogic";
import { useLocation } from "react-router-dom";
import ViewQuoteModal from "./ViewQuoteModal";
import BindModal from "../components/BindModal";
import CancelIcon from "@material-ui/icons/Cancel";
import ReactLoading from "react-loading";
import {
  changeIsViewQuoteModalOpen,
  getCovers,
  getExcelApiStatus,
  getisViewQuoteModalOpen,
  getParticularCover,
  getProspectid,
  getResponseDetails,
  updateCheckedForCompareToDb,
  getPolicyJustBinded,
  getInsuerEmailv2,
  getInsurerCode,
  getIRSCodeOnly,
  getSelectedInsurerEmails,
  getStiEmailData,
  getDataRequiredForEmail,
  getResponseBindType,
  getProspectDetails,
  updateCover,
  updateCovers,
  updateBindType,
  getTempPolicy,
  updatePolicyCovers,
} from "../store/quotes";
import {
  getPDFV2fromURL,
  bindModalOpened,
  getBindModalState,
  getPDFV2status,
  getPDFOnlyStatus,
  bindExternalResponse,
  openBindQuoteConformationModal,
  getBindExternal,
  resetBindExternal,
} from "../store/components";
import DropdownButton from "react-bootstrap/DropdownButton";
import Dropdown from "react-bootstrap/Dropdown";
import { toast } from "react-toastify";
import { PossibleApiStatusValues } from "../store/helperfuncs";
import Popover from "@material-ui/core/Popover";
import { getBrokerInformation } from "../store/broker";
import { useEffect, useState, useMemo } from "react";
import ActionMessageButton from "../general/ActionMessageButton";
import { getFormState, verifyBrokerAgainstProspectQF } from "../store/qf";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Button } from "react-bootstrap";
import BindIcon from "@material-ui/icons/Link"; // Replace with the icon you prefer
import VisibilityIcon from "@material-ui/icons/Visibility"; // Icon for View Quote
import EditIcon from "@material-ui/icons/Edit"; // Icon for Edit Quote
import InfoIcon from "@material-ui/icons/Info"; // Icon for Info Button
import EmailIcon from "@material-ui/icons/Email"; // or MailIcon from '@material-ui/icons/Mail';
import DescriptionIcon from "@material-ui/icons/Description"; // Icon for Document
import DollarIcon from "@material-ui/icons/AttachMoney";
import {
  TextField,
  Typography,
  Box,
  Grid,
  RadioGroup,
  Radio,
  Divider,
  FormControlLabel,
  makeStyles,
  InputAdornment,
} from "@material-ui/core";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import translations from "../utils/translations";
import { addTransaction } from "../store/transactions";
// import { PDFDownloadLink } from "@react-pdf/renderer";

// import LloydsPdfComponent from "../components/CustomPdfs/lloyds/LloydsPdfComponent.jsx";

// Helper functions for French-friendly data
const getLocalizedField = (field, lang = "en") => {
  if (!field) return "";
  if (typeof field === "string") return field; // Backward compatibility
  return field[lang] || field.en || field; // Language-aware with fallbacks
};

const buildOperationString = (operationList, lang = "en") => {
  if (!operationList) return "";
  if (typeof operationList === "string") return operationList; // Backward compatibility
  if (!Array.isArray(operationList)) return "";
  return operationList.map(op => 
    `-  ${op.id}: ${getLocalizedField(op.name, lang)} -`
  ).join("");
};

export function CoverageDeciderComp({ responseid, quotesource, insurercode }) {
  const { search } = useLocation();
  const prospectid = search.substring(4);

  const ismodalopen = useSelector(getisViewQuoteModalOpen({ responseid }));

  const excelApiStatus = useSelector(getExcelApiStatus(responseid));
  const cover = useSelector(
    getParticularCover(responseid, getCoverIdForCoverageLevel())
  );

  if (excelApiStatus === PossibleExcelApiStatusValues.loading) {
    return (
      <LoadingBars
        type={"bubbles"}
        color={theme.COLORS.secondary_orange}
      ></LoadingBars>
    );
  }

  if (excelApiStatus === PossibleExcelApiStatusValues.failed) {
    return (
      <CoverageLevel
        insurercode={insurercode}
        coveragelevel={"-"}
        buttontext={"View Quote"}
        prospectid={prospectid}
        responseid={responseid}
      ></CoverageLevel>
    );
  }

  const buttonTextDecider = (quotesource) => {
    if (quotesource === "inhouse" || quotesource === "external")
      return "View Quote";
    if (quotesource === "manual") return "Add/Edit";
    return "View Quote";
  };

  return (
    <CoverageLevel
      showPercentage={true}
      coveragelevel={cover}
      buttontext={buttonTextDecider(quotesource)}
      prospectid={prospectid}
      quotesource={quotesource}
      responseid={responseid}
    ></CoverageLevel>
  );
}
const DisplayOrangeButton = ({
  buttontext,
  prospectid,
  quotesource,
  responseid,
  coveragelevel,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const insurercode = useSelector(getInsurerCode({ responseid }));
  const covers = useSelector(getCovers(responseid));
  const policyJustBinded = useSelector(getPolicyJustBinded);
  const stiEmailData = useSelector(getStiEmailData);
  const insurerDetail = useSelector(getInsuerEmailv2(insurercode));
  const responseBindType = useSelector(getResponseBindType({ responseid }));
  const formstate = useSelector(getFormState);
  const gotResponseDetails = useSelector(getResponseDetails);
  const gotProspectDetails = useSelector(getProspectDetails);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const { information } = useSelector(getBrokerInformation);
  const bindPermission = "bind";
  const asArray = Object.values(gotResponseDetails);
  const [showInfo, setShowInfo] = useState(false);
  const [showFees, setShowFees] = useState(false);
  const [showBindType7Menu, setshowBindType7Menu] = useState(false);
  const [showDownloads, setShowDownloads] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [handleBindModal, setHandleBindModal] = useState(false);
  const [handleReferModal, setHandleReferModal] = useState(false);
  const [editCovers, setEditCovers] = useState("no");
  const [underwriterInfo, setunderwriterInfo] = useState({
    name: "",
    email: "",
    date: "",
  });
  const [bind7Covers, setbind7Covers] = useState({
    quote: covers?.[206],
    fees: covers?.[4],
    total: covers?.[3],
  });
  const isProceedDisabled = Object.values(underwriterInfo).some(
    (value) => value.trim() === ""
  );
  const irsCodeOnly = useSelector(getIRSCodeOnly);

  // Use the language preference from broker information
  const languagepreference = information.languagepreference;
  const actionsDropdown = translations[languagepreference].actionsDropdown;

  let emailList = useSelector(getSelectedInsurerEmails);

  let { brokerages, user, phonenumber } = information;
  let { email, name } = user;

  const validateBeforeSendBind = asArray.filter(
    (data) => data.checkedforcompare === true
  );
  const bindExternal = useSelector(getBindExternal);
  const isLargeScreen = window.innerWidth <= 1719;

  const getEmailBodyV2 = (reason) =>
    `
Hi,

${actionsDropdown.emailBodyIntro}

The reason for referral was stated as: ${reason}

Summary details are as follows:

Company name:	${stiEmailData.clientBusinessName}

Address: ${stiEmailData.clientAddress}

Renewal date: ${stiEmailData.renewalDate}

Vertical:	${getLocalizedField(stiEmailData.verticalName, languagepreference)}

Operation(s):	${buildOperationString(stiEmailData.operationList, languagepreference)}

${stiEmailData[69000]}

I look forward to your thoughts and hope that we have an opportunity to work with you on this client.

If you have any questions, please let me know.

Thanks,

${name}
  `;

  const policyId = useMemo(
    () => gotResponseDetails[responseid]?.policy?._id,
    [gotResponseDetails, responseid]
  );

  useEffect(() => {
    if (covers && covers[1] === "Refer") {
      dispatch(getDataRequiredForEmail({ prospectid }));
    }
  }, [covers]);

  let [bindType, setbindType] = useState(insurerDetail.bindtype);
  useEffect(() => {
    if (!responseBindType) return;
    setbindType(responseBindType);
    if (responseBindType == 9) {
      if (policyId) return;
      let attempts = 0;
      const maxAttempts = 10;
      const interval = setInterval(() => {
        attempts++;
        dispatch(getTempPolicy({ insurercode, responseid, prospectid }));
        if (policyId || attempts >= maxAttempts) {
          clearInterval(interval); // Stop polling once policy is found or max attempts reached
        }
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [responseBindType, policyId]);

  useEffect(() => {
    if (bindExternal === "loading") {
      toast(actionsDropdown.bindInProgress, {
        toastId: "bindToast",
        type: "info",
      });
    } else if (["Failed", "failed"].includes(bindExternal.status)) {
      setTimeout(() => {
        dispatch(resetBindExternal());
        toast.update("bindToast", {
          type: "error",
          render: actionsDropdown.bindingFailed,
        });
      }, 2000);
    } else if (bindExternal.success) {
      toast(actionsDropdown.bindSuccessfull, {
        toastId: "bindToast",
        type: "success",
      });
      let binder_id = bindExternal.policyData.policy._id;
      setTimeout(() => {
        dispatch(resetBindExternal());
        document.location.href = `/binder?id=${binder_id}`;
      }, 2000);
    }
  }, [bindExternal]);

  const handleDropdownToggle = (isOpen, event, metadata) => {
    if (metadata.source === "select") {
      return; // Prevent dropdown from closing when an item is selected
    }
    if (!isOpen) {
      setShowInfo(false);
      setShowDownloads(false);
      setShowFees(false);
      setshowBindType7Menu(false);
    }
    setDropdownOpen(isOpen);
  };

  const handleBindToggle = (responseId) => {
    Object.entries(gotResponseDetails).forEach(([key, value]) => {
      if (key !== responseId && value.checkedforcompare) {
        dispatch(
          updateCheckedForCompareToDb({
            responseid: key,
            checkedstate: false,
          })
        );
      }
    });
  };

  const handleInfoClick = (event) => {
    setAnchorEl(event.currentTarget);
    setShowInfo(true);
    setDropdownOpen(true);
  };

  const handleFeesClick = (event) => {
    setAnchorEl(event.currentTarget);
    setShowFees(true);
    setDropdownOpen(true);
  };

  function handleDownloadInsurerClick(event) {
    setAnchorEl(event.currentTarget);
    setShowDownloads(true);
  }

  const handleInfoClose = () => {
    setAnchorEl(null);
    setShowInfo(false);
    setDropdownOpen(false);
  };

  const handleFeesClose = () => {
    setAnchorEl(null);
    setShowFees(false);
    setDropdownOpen(false);
  };

  const showBindOption = (insurerType, insurerBindType, quoteStatus) => {
    const bindTypeInt = parseInt(insurerBindType, 10);
    const allowedBindTypes = [2, 5, 6, 4, 9];
    return (
      (insurerType === "external" ||
        insurerType === "inhouse" ||
        insurerType === "manual") &&
      allowedBindTypes.includes(bindTypeInt) &&
      ["Quote", "Accept", "Quote-Refer"].includes(quoteStatus)
    );
  };

  const showFirmUpBindOption = (insurerType, insurerBindType, quoteStatus) => {
    const bindTypeInt = parseInt(insurerBindType, 10);
    const allowedBindTypes = [1, 3];
    return (
      (insurerType === "external" || insurerType === "inhouse") &&
      allowedBindTypes.includes(bindTypeInt) &&
      (quoteStatus === "Quote" || quoteStatus === "Accept")
    );
  };

  const showReferToInsurerOption = (
    insurerType,
    insurerBindType,
    quoteStatus,
    referStatus
  ) => {
    const bindTypeInt = parseInt(insurerBindType, 10);
    const allowedReferBindTypes = [1, 3, 4];
    return (
      allowedReferBindTypes.includes(bindTypeInt) &&
      quoteStatus !== "Decline" &&
      referStatus !== "Declined"
    );
  };

  const showEditQuoteV1Option = (insurerType) => {
    return insurerType === "manual";
  };

  const showEditQuoteV2Option = (insurerType, insurerBindType, quoteStatus) => {
    const bindTypeInt = parseInt(insurerBindType, 10);
    const allowedEditV2BindTypes = [1, 2];
    return (
      insurerType === "inhouse" &&
      allowedEditV2BindTypes.includes(bindTypeInt) &&
      quoteStatus === "Quote"
    );
  };

  const showViewQuoteOption = (insurerType, insurerBindType, quoteStatus) => {
    const bindTypeInt = parseInt(insurerBindType, 10);
    const allowedViewQuoteBindTypes = [1, 2, 3, 4, 5, 6];

    // Convert quoteStatus to a string if it is not null/undefined
    const safeQuoteStatus = quoteStatus != null ? quoteStatus.toString() : "";

    return (
      allowedViewQuoteBindTypes.includes(bindTypeInt) &&
      (safeQuoteStatus === "Quote" ||
        safeQuoteStatus.toLowerCase().includes("quote"))
    );
  };

  const showInfoOption = (insurerType, insurerBindType, quoteStatus) => {
    return quoteStatus === "Quote";
  };

  const onBindModalOpenHandler = () => {
    dispatch(bindModalOpened());
  };

  const alertForSelect = (arg) => {
    if (arg === 0) {
      toast(
        <div style={{ fontFamily: "GibsonRegular" }}>
          {actionsDropdown.alertSelectOne}
        </div>
      );
    } else {
      toast(
        <div style={{ fontFamily: "GibsonRegular" }}>
          {actionsDropdown.alertSelectOnlyOne}
        </div>
      );
    }
  };

  function userHasPermission(action) {
    const permissions = information?.permissions;
    const hasPermission = _.findIndex(permissions, { value: action });
    return hasPermission !== -1;
  }

  const useStyles = makeStyles({
    paper: {
      boxShadow: "0px 0px 9px 0px rgba(0,0,0,0.5)",
      width: (props) => (props.width ? `${props.width}px` : "calc(100%-64px)"),
      height: (props) => (props.height ? `${props.height}px` : "100%"),
    },
  });
  const classes = useStyles({ height: "100px", width: "100px" });

  return (
    <>
      {insurerDetail.quotesby !== "external" && covers == null && (
        <Button
          className="custom-edit-button"
          onClick={() => {
            document.location.href = `/editresponse?id=${responseid}&pid=${prospectid}`;
          }}
        >
          {actionsDropdown.editQuote}
        </Button>
      )}
      {covers != null && (
        <DropdownButton
          className="custom-dropdown-button"
          title={actionsDropdown.title}
          id="bg-nested-dropdown"
          show={dropdownOpen}
          onToggle={handleDropdownToggle}
        >
          {showBindOption(insurerDetail.quotesby, bindType, covers[1]) && (
            <Dropdown.Item
              eventKey="1"
              disabled={
                !userHasPermission(bindPermission) ||
                policyJustBinded ||
                gotProspectDetails === true
              }
              onClick={(event) => {
                handleBindToggle(responseid);
                setAnchorEl(event.currentTarget);
                dispatch(
                  updateCheckedForCompareToDb({
                    responseid,
                    checkedstate: true,
                  })
                );
                if (
                  "external" === gotResponseDetails[responseid].source &&
                  false
                ) {
                  dispatch(bindExternalResponse({ responseid, prospectid }));
                } else if (bindType == "9") {
                  setshowBindType7Menu(true);
                } else {
                  setHandleBindModal(true);
                }
              }}
              aria-describedby={"BindPopOver"}
            >
              <BindIcon fontSize="small" className="icon-gap" />{" "}
              {actionsDropdown.bindQuote}
              <Popover
                id={"BindPopOver"}
                open={showBindType7Menu}
                anchorEl={anchorEl}
                onClose={() => {
                  setshowBindType7Menu(false);
                }}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                PaperProps={{
                  style: {
                    padding: "1em",
                  },
                }}
                classes={classes}
                onClick={(event) => {
                  event.stopPropagation();
                }}
              >
                <div className="popover-header">
                  <Typography variant="subtitle1" gutterBottom>
                    {actionsDropdown.bindConfirmationHeader}
                  </Typography>
                </div>
                <div
                  className="popover-content"
                  style={{
                    maxWidth: "400px",
                    maxHeight: "500px",
                    overflowX: "hidden",
                  }}
                >
                  <Typography variant="body2" gutterBottom>
                    {actionsDropdown.bindConfirmationText}
                  </Typography>
                  <Grid container spacing={2} style={{ marginTop: "10px" }}>
                    <Grid item xs={6}>
                      <Typography variant="body2">
                        {actionsDropdown.finalPremiumQuoted}
                      </Typography>
                    </Grid>
                    <Grid item xs={6} style={{ textAlign: "right" }}>
                      <TextField
                        variant="standard"
                        fullWidth
                        size="small"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">$</InputAdornment>
                          ),
                        }}
                        defaultValue={`${(Number(covers[206]) || 0).toFixed(
                          2
                        )}`}
                        value={bind7Covers.quote}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (isNaN(value) || value === "") {
                            setbind7Covers((oldVals) => ({
                              ...oldVals,
                              quote: 0,
                              total: parseFloat(oldVals.quote) || 0,
                            }));
                            return;
                          }
                          setbind7Covers((oldVals) => ({
                            ...oldVals,
                            quote: parseFloat(e.target.value),
                            total:
                              parseFloat(e.target.value) +
                              parseFloat(oldVals.fees),
                          }));
                        }}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="body2">
                        {actionsDropdown.insurerFees}
                      </Typography>
                    </Grid>
                    <Grid item xs={6} style={{ textAlign: "right" }}>
                      <TextField
                        variant="standard"
                        fullWidth
                        size="small"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">$</InputAdornment>
                          ),
                        }}
                        defaultValue={`${(Number(covers[4]) || 0).toFixed(2)}`}
                        value={bind7Covers.fees}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (isNaN(value) || value === "") {
                            setbind7Covers((oldVals) => ({
                              ...oldVals,
                              fees: 0,
                              total: parseFloat(oldVals.quote) || 0,
                            }));
                            return;
                          }
                          setbind7Covers((oldVals) => ({
                            ...oldVals,
                            fees: parseFloat(e.target.value),
                            total:
                              parseFloat(e.target.value) +
                              parseFloat(oldVals.quote),
                          }));
                        }}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="body2">
                        <strong>{actionsDropdown.totalPremiumFees}</strong>
                      </Typography>
                    </Grid>
                    <Grid item xs={6} style={{ textAlign: "right" }}>
                      <Typography variant="body2">
                        <strong>
                          ${(Number(bind7Covers.total) || 0).toFixed(2)}
                        </strong>
                      </Typography>
                    </Grid>
                  </Grid>
                  <Divider style={{ margin: "15px 0" }} />
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <TextField
                        label={actionsDropdown.underwriterName}
                        variant="standard"
                        fullWidth
                        size="small"
                        inputProps={{ pattern: ".*" }}
                        defaultValue={underwriterInfo["name"]}
                        value={underwriterInfo["name"]}
                        onChange={(e) => {
                          setunderwriterInfo((prev) => ({
                            ...prev,
                            name: e.target.value,
                          }));
                        }}
                        onKeyDown={(e) => {
                          if (e.key === " ") {
                            e.preventDefault();
                            setunderwriterInfo((prev) => ({
                              ...prev,
                              name: (prev.name || "") + " ",
                            }));
                          }
                        }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        label={actionsDropdown.underwriterEmail}
                        type="email"
                        variant="standard"
                        fullWidth
                        size="small"
                        onChange={(e) => {
                          setunderwriterInfo((prev) => ({
                            ...prev,
                            email: e.target.value,
                          }));
                        }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        label={actionsDropdown.dateConfirmedByUnderwriter}
                        type="date"
                        variant="outlined"
                        fullWidth
                        size="small"
                        InputLabelProps={{ shrink: true }}
                        onChange={(e) => {
                          setunderwriterInfo((prev) => ({
                            ...prev,
                            date: e.target.value,
                          }));
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Typography
                    variant="body2"
                    style={{ margin: "15px 0 5px" }}
                    gutterBottom
                  >
                    {actionsDropdown.editCoveragesQuestion}
                  </Typography>
                  <RadioGroup
                    row
                    defaultValue="no"
                    onChange={(event) => setEditCovers(event.target.value)}
                  >
                    <FormControlLabel
                      value="yes"
                      control={<Radio />}
                      label={actionsDropdown.radioYes}
                    />
                    <FormControlLabel
                      value="no"
                      control={<Radio />}
                      label={actionsDropdown.radioNo}
                    />
                  </RadioGroup>
                  <Typography
                    variant="body2"
                    style={{
                      margin: "15px 0",
                      display: editCovers == "no" ? "none" : null,
                    }}
                  >
                    {actionsDropdown.editCoveragesExplanation}
                  </Typography>
                  <Button
                    variant="contained"
                    color="secondary"
                    disabled={isProceedDisabled}
                    fullWidth
                    style={{
                      marginTop: "4px",
                      backgroundColor: isProceedDisabled
                        ? "grey"
                        : "rgb(73, 168, 214)",
                      color: "white",
                    }}
                    onClick={() => {
                      let newCovers = {
                        ...covers,
                        3: bind7Covers.total,
                        206: bind7Covers.quote,
                        4: bind7Covers.fees,
                      };
                      dispatch(
                        updatePolicyCovers({
                          id: gotResponseDetails[responseid].policy?._id,
                          covers: newCovers,
                        })
                      );
                      dispatch(
                        updateCover({
                          responseid,
                          policydata: newCovers,
                          locationdata: null,
                          comment: null,
                          coverasisOverride: true,
                        })
                      );
                      dispatch(
                        updateCovers({
                          responseid,
                          covers: newCovers,
                        })
                      );
                      let transactionData = {
                        prospectid,
                        oldstatus: "Quote Confirmed",
                        newstatus: "Quote Confirmed",
                        newstatus: null,
                        comment: Object.entries({
                          ...underwriterInfo,
                          underwriter: underwriterInfo.name,
                          Insurer: insurerDetail.name,
                        })
                          .filter(([key]) => key !== "name")
                          .map(([key, value]) => `${key}:${value}`)
                          .join("\n"),
                        otherDetails: { premium: bind7Covers.total },
                      };
                      dispatch(addTransaction(transactionData));
                      dispatch(
                        updateBindType({
                          responseid,
                          prospectid,
                          bindType: "2",
                          underwriterInfo,
                        })
                      );
                      setshowBindType7Menu(false);
                      if (editCovers == "yes") {
                        setTimeout(() => {
                          document.location.href = `/editresponse?id=${responseid}&pid=${prospectid}`;
                        }, 2000);
                      } else {
                        setHandleBindModal(true);
                      }
                    }}
                  >
                    {actionsDropdown.proceedButton}
                  </Button>
                </div>
              </Popover>
            </Dropdown.Item>
          )}
          {showFirmUpBindOption(
            insurerDetail.quotesby,
            bindType,
            covers[1]
          ) && (
            <Dropdown.Item
              eventKey="2"
              disabled={
                !userHasPermission(bindPermission) ||
                policyJustBinded ||
                gotProspectDetails === true
              }
              onClick={() => {
                handleBindToggle(responseid);
                dispatch(
                  updateCheckedForCompareToDb({
                    responseid,
                    checkedstate: true,
                  })
                );
                setHandleBindModal(true);
              }}
            >
              <BindIcon fontSize="small" className="icon-gap" />{" "}
              {actionsDropdown.firmUpAndBindQuote}
            </Dropdown.Item>
          )}
          {covers[1] === "Refer" && (
            <Dropdown.Item
              eventKey="3"
              onClick={async () => {
                toast(actionsDropdown.emailWillBeCreated, { type: "info" });
                if (stiEmailData && formstate?.j?.nodestate["69001"]?.answer) {
                  setHandleReferModal(true);
                } else {
                  dispatch(
                    getPDFV2fromURL({
                      id: irsCodeOnly,
                      downloadingEml: true,
                      mailto: email,
                      bcc: emailList.join(";"),
                      body: getEmailBodyV2(covers[2]),
                      subject: `Quotey Referral for ${stiEmailData.clientBusinessName}`,
                      pdf_language_selected:languagepreference
                    })
                  );
                }
              }}
            >
              <EmailIcon fontSize="small" className="icon-gap" />{" "}
              {actionsDropdown.referToInsurer}
            </Dropdown.Item>
          )}
          {showEditQuoteV1Option(insurerDetail.quotesby) && (
            <Dropdown.Item
              eventKey="4"
              onClick={() => {
                document.location.href = `/editresponse?id=${responseid}&pid=${prospectid}`;
              }}
            >
              <EditIcon fontSize="small" className="icon-gap" />{" "}
              {actionsDropdown.editQuote}
            </Dropdown.Item>
          )}
          {showViewQuoteOption(insurerDetail.quotesby, bindType, covers[1]) && (
            <Dropdown.Item
              eventKey="5"
              onClick={() => {
                document.location.href = `/cv?id=${prospectid}&rid=${responseid}`;
              }}
            >
              <VisibilityIcon fontSize="small" className="icon-gap" />{" "}
              {actionsDropdown.viewQuote}
            </Dropdown.Item>
          )}
          <Dropdown.Item
            aria-describedby={"info"}
            eventKey="6"
            onClick={handleInfoClick}
          >
            <InfoIcon fontSize="small" className="icon-gap" />{" "}
            {actionsDropdown.info}
            <Popover
              id={"info"}
              open={showInfo}
              anchorEl={anchorEl}
              onClose={handleInfoClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              classes={{ paper: "popover" }}
            >
              <div className="popover-header">
                {actionsDropdown.quoteInformation || "Quote Information"}
              </div>
              <div className="popover-content">{covers[2]}</div>
            </Popover>
          </Dropdown.Item>
          {gotResponseDetails[responseid].files &&
            gotResponseDetails[responseid].files.length > 0 && (
              <Dropdown.Item
                aria-describedby={"downloads"}
                eventKey="7"
                onClick={handleDownloadInsurerClick}
              >
                <DescriptionIcon fontSize="small" className="icon-gap" />{" "}
                {actionsDropdown.downloadInsurerDocument}
                <Popover
                  id={"downloads"}
                  open={showDownloads}
                  anchorEl={anchorEl}
                  onClose={() => {
                    setShowDownloads(false);
                  }}
                  classes={{ paper: "popover-downloads" }}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                  }}
                >
                  <div className="popover-header">
                    {actionsDropdown.documents || "Documents"}
                  </div>
                  <div className="popover-content">
                    <DownloadFilesList
                      close={() => {
                        setShowDownloads(false);
                      }}
                      files={gotResponseDetails[responseid].files}
                    />
                  </div>
                </Popover>
              </Dropdown.Item>
            )}
          {["external", "inhouse"].includes(insurerDetail.quotesby) &&
            ["Quote", "Quote-Refer"].includes(covers?.[1]) && (
              <Dropdown.Item
                aria-describedby={"fees"}
                eventKey="7"
                onClick={handleFeesClick}
              >
                <DollarIcon fontSize="small" className="icon-gap" />{" "}
                {actionsDropdown.fees || "Fees"}
                <Popover
                  id={"fees"}
                  open={showFees}
                  anchorEl={anchorEl}
                  onClose={handleFeesClose}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                  classes={{ paper: "popover" }}
                >
                  <div className="popover-header">
                    {actionsDropdown.addBrokerFee || "Add a Broker Fee"}
                  </div>
                  <div className="popover-content">
                    <InlineFeesForm
                      covers={covers}
                      responseid={responseid}
                      setDropdownOpen={setDropdownOpen}
                      setShowFees={setShowFees}
                    />
                  </div>
                </Popover>
              </Dropdown.Item>
            )}
        </DropdownButton>
      )}
      <Modal
        isOpen={handleBindModal}
        ariaHideApp={false}
        shouldCloseOnEsc={false}
        style={{
          overlay: {
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: theme.COLORS.rgba_primary_navyblue,
            color: "white",
          },
          content: {
            height: !isLargeScreen ? "74vh" : "90vh",
            width: !isLargeScreen ? "69vw" : "91vw",
            position: "absolute",
            top: "7vh",
            left: !isLargeScreen ? "20vw" : "5vw",
            right: 0,
            bottom: 0,
            background: theme.COLORS.primary_navyblue,
            WebkitOverflowScrolling: "touch",
            border: "8px solid white",
            borderRadius: "30px",
            padding: 0,
            overflow: "auto",
          },
        }}
      >
        <BindModal
          insurerDetail={insurerDetail}
          insurerId={responseid}
          bindtype={bindType}
          handleBindModalClose={() => {
            setHandleBindModal(false);
          }}
        />
      </Modal>
      {formstate.j && stiEmailData && (
        <AddDocumentsModal
          show={handleReferModal}
          closeModal={() => {
            setHandleReferModal(false);
          }}
        />
      )}
    </>
  );
};

const CoverageLevel = ({
  coveragelevel,
  buttontext,
  prospectid,
  showPercentage,
  quotesource,
  responseid,
  insurercode,
}) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        width: "80%",
        justifyContent: "space-between",
      }}
    >
      <NormalText
        text={
          coveragelevel
            ? showPercentage
              ? `${coveragelevel}%`
              : coveragelevel
            : "-"
        }
      ></NormalText>
      <div style={{ padding: "3px" }}>
        <DisplayOrangeButton
          buttontext={buttontext}
          prospectid={prospectid}
          quotesource={quotesource}
          responseid={responseid}
          coveragelevel={coveragelevel}
          insurercode={insurercode}
        ></DisplayOrangeButton>
      </div>
      {/* <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <DescriptionIcon fontSize="small" />
      </div> */}
      {/* <ViewQuoteModal
            isopen={ismodalopen}
            responseid={responseid}
          ></ViewQuoteModal> */}
    </div>
  );
};

const AddDocumentsModal = (props) => {
  var documents = [];

  const dispatch = useDispatch();
  let emailList = useSelector(getSelectedInsurerEmails);
  const stiEmailData = useSelector(getStiEmailData);
  const pdfstatus = useSelector(getPDFV2status);
  const irsCodeOnly = useSelector(getIRSCodeOnly);
  let { information } = useSelector(getBrokerInformation);
  const languagepreference = information.languagepreference;
  const formstate = useSelector(getFormState);
  let { brokerages, user, phonenumber } = information;
  var filesData = formstate?.j?.nodestate["69001"]?.answer;
  let { email, name } = user;

  const showLoading = ({ pdfstatus }) => {
    if (pdfstatus === PossibleApiStatusValues.loading) return true;

    return false;
  };

  const Loading = () => {
    return (
      <ReactLoading
        type={"bars"}
        color={"white"}
        height={"70%"}
        width={"10%"}
      />
    );
  };
  let subject = `New Submission for ${stiEmailData.clientBusinessName}`;
  const getEmailBodyV2 = () =>
    `
Hi,

Please find attached a submission for our client, completed on Quotey.io.

Summary details are as follows:

Company name:	${stiEmailData.clientBusinessName}
  
Address:${stiEmailData.clientAddress}
  
Renewal date: ${stiEmailData.renewalDate}	
  
Vertical:	${getLocalizedField(stiEmailData.verticalName, languagepreference)}	
  
Operation(s):	${buildOperationString(stiEmailData.operationList, languagepreference)}
  
${stiEmailData[69000]}
  
I look forward to your thoughts and hope that we have an opportunity to work with you on this client.

If you have any questions, please let me know.
  
Thanks,

${name}
`;
  return (
    <Modal
      size="md"
      isOpen={props.show}
      ariaHideApp={false}
      shouldCloseOnEsc={true}
      centered
      style={{
        overlay: {
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: theme.COLORS.rgba_primary_navyblue,
        },
        content: {
          height: "35vh",
          width: "25vw",
          position: "absolute",
          top: "15vh",
          left: "29vw",
          background: "#eef3f6",
          WebkitOverflowScrolling: "touch",
          border: "8px solid " + theme.COLORS.white_Indo,
          borderRadius: "20px",
          padding: 0,
          overflow: "hidden",
          backgroundColor: theme.COLORS.primary_navyblue,
        },
      }}
    >
      <div style={{ position: "absolute", top: 10, right: 10 }}>
        <CancelIcon
          fontSize="large"
          style={{ cursor: "pointer", color: "white" }}
          onClick={() => {
            props.closeModal();
          }}
        ></CancelIcon>
      </div>
      <div>
        <div
          style={{
            width: "100%",
            height: "7vh",
            backgroundColor: theme.COLORS.secondary_skyblue,
            fontSize: "1.9vmin",
            letterSpacing: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "end",
            color: "white",
            fontFamily: "GibsonRegular",
          }}
        >
            {translations[languagepreference].uploadDocumentsTitle}
          {/* Upload Additional Documents with Email */}
        </div>
        <div
          style={{
            height: "18vh",
            overflowY: "auto",
            display: "flex",
            flexDirection: "column",
            marginLeft: "6%",
            paddingTop: "10px",
          }}
        >
          {filesData?.map((x, idx) => {
            return (
              <>
                <Form.Check
                  inline
                  label={x.fileName}
                  style={{ color: "white" }}
                  name="group1"
                  type="checkbox"
                  id={`inline-checkbox-${idx}`}
                  onClick={(e) => {
                    if (e.target.checked) {
                      documents.push(x);
                    } else {
                      documents = documents.filter(
                        (doc) => doc.s3Upload.Etag != x.s3Upload.Etag
                      );
                    }
                    return;
                  }}
                />
                {}
              </>
            );
          })}
        </div>
      </div>
      {/* <button

        onClick={(e) => {
          
          dispatch(
            getPDFV2fromURL({
              id: irsCodeOnly,
              downloadingEml: true,
              mailto: email,
              bcc:  modalObj?.emailInfo?.emailString,
              body:  modalObj?.emailInfo?.emailBody,
              subject: modalObj?.emailInfo?.subject,
              additionalDocuments: documents
            })
          );
        }}
      >Send Email</button> */}
      <div
        style={{
          width: "50%",
          margin: "auto",
        }}
      >
        <ActionMessageButton
          text={""}
          style={{
            height: "20%",
            width: "50%",
            margin: "auto",
          }}
          buttonText={
            showLoading({ pdfstatus: pdfstatus }) ? (
              <Loading></Loading>
            ) : ( translations[languagepreference].createEmailButtonText
              
            )
          }
          buttonClick={() => {
            dispatch(
              getPDFV2fromURL({
                id: irsCodeOnly,
                downloadingEml: true,
                mailto: email,
                bcc: emailList.join(";"),
                body: getEmailBodyV2(),
                subject: `New Submission for ${stiEmailData.clientBusinessName}`,
                additionalDocuments: documents,
                pdf_language_selected:languagepreference
              })
            );
          }}
          buttonTextSize="18px"
        ></ActionMessageButton>
      </div>
    </Modal>
  );
};

const InlineFeesForm = ({
  covers,
  responseid,
  setShowFees,
  setDropdownOpen,
}) => {
  const dispatch = useDispatch();
  let { information } = useSelector(getBrokerInformation);

  const languagepreference = information.languagepreference;
  // Access the translation object for the InlineFeesForm
  const inlineFeesFormTranslation =
    translations[languagepreference]?.inlineFeesForm;

  const [brokerfee, setBrokerFees] = useState(covers[207] || 0);
  const [totalPremium, setTotalPremium] = useState(covers[3] || 0);

  return (
    <Box
      component="form"
      onSubmit={(e) => {
        e.preventDefault();
        let newCovers = { ...covers, 3: totalPremium, 207: brokerfee };
        dispatch(
          updateCover({
            responseid: responseid,
            policydata: newCovers,
            locationdata: null,
            comment: null,
            coverasisOverride: true,
          })
        );
        dispatch(
          updateCovers({
            responseid: responseid,
            covers: { ...newCovers },
          })
        );
        setShowFees(false);
        setDropdownOpen(false);
      }}
      onClick={(event) => {
        event.stopPropagation();
      }}
      sx={{
        maxWidth: 500,
        margin: "20px auto",
        overflowX: "hidden",
        display: "flex",
        flexDirection: "column",
        gap: 3,
        padding: 2,
        border: "1px solid #ccc",
        borderRadius: 2,
      }}
    >
      {/* Broker Fee */}
      <Grid container alignItems="center" spacing={2}>
        <Grid item xs={6}>
          <Typography
            variant="body1"
            component="label"
            htmlFor="brokerFeeInput"
          >
            {inlineFeesFormTranslation.brokerFeeLabel}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <TextField
            id="brokerFeeInput"
            variant="standard"
            size="small"
            fullWidth
            placeholder={`$${covers[207] ?? 0}`}
            inputProps={{ style: { fontSize: 15 } }}
            onChange={(e) => {
              let value = e.target.value || 0;
              let insurer_fee = covers[4] ? parseFloat(covers[4]) : 0;
              if (isNaN(value)) return;
              setBrokerFees(value);
              let totalPrem =
                parseFloat(covers[206]) + insurer_fee + parseFloat(value);
              setTotalPremium(totalPrem);
            }}
          />
        </Grid>
      </Grid>

      {/* Premium */}
      <Grid container alignItems="center" spacing={2}>
        <Grid item xs={6}>
          <Typography variant="body1" component="label" htmlFor="premiumLabel">
            {inlineFeesFormTranslation.premiumLabel}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="body2" id="premiumLabel">
            ${covers[206]}
          </Typography>
        </Grid>
      </Grid>

      {/* Insurer Fee */}
      <Grid container alignItems="center" spacing={2}>
        <Grid item xs={6}>
          <Typography
            variant="body1"
            component="label"
            htmlFor="insurerFeeLabel"
          >
            {inlineFeesFormTranslation.insurerFeeLabel}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="body2" id="insurerFeeLabel">
            ${covers[4]}
          </Typography>
        </Grid>
      </Grid>

      {/* Total Premium & Fees */}
      <Grid container alignItems="center" spacing={2}>
        <Grid item xs={6}>
          <Typography variant="body1" component="label" htmlFor="totalLabel">
            {inlineFeesFormTranslation.totalPremiumFeesLabel}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="body2" id="totalLabel">
            ${totalPremium}
          </Typography>
        </Grid>
      </Grid>

      {/* Submit Button */}
      <Button type="submit" variant="contained" color="primary">
        {inlineFeesFormTranslation.doneButton}
      </Button>
    </Box>
  );
};
